module.exports = __webpack_public_path__ + "img/cashft-mastery-card.b53bea7.webp";